import { InjectionToken } from '@angular/core';

export const VERSION = new InjectionToken<string>('version');
